<template>
  <div class="container">
    <div class="event">
      <div v-for="(t, i) in eventList" :key="i" class="event-item active">
        <div>
          <div>{{`${t.name}的${t.selectName}`}}</div>
          <div class="num">{{t.totalCount}}</div>
        </div>
        <div class="icon">
          <i class="iconfont icon-shuju3"></i>
        </div>
        <div class="event-close f-c-c pointer" @click="eventDelete(i)">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="event-item f-c-c" style="justify-content: center" v-if="eventList.length < 8">
        <div style="text-align:center" class="f f--c fd-c pointer" @click="eventAnalysisLabelVisible = true">
          <p><i class="el-icon-plus" style="font-weight:bold;font-size:20px"></i></p>
          <p>添加新指标</p>
        </div>
      </div>
    </div>
    <div class="f f-e-c bg-white" style="padding: 10px">
      <el-radio-group v-model="showChart" size="mini" @change="radioChange">
        <el-radio-button label="myChart"><i class="el-icon-s-marketing"></i></el-radio-button>
        <el-radio-button label="histogram"><i class="el-icon-s-data"></i></el-radio-button>
      </el-radio-group>
    </div>
    <div id="myChart" v-if="showChart === 'myChart'" :key="renderKey"></div>
    <div id="histogram" v-if="showChart === 'histogram'" :key="renderKey"></div>
    <div class="f-e" style="margin-top: 10px">
      <el-button @click="exportData">数据导出</el-button>
    </div>
    <div class="bg-white" style="margin-top:20px">
      <el-table
        :data="dataList"
        style="width: 100%"
      >
        <el-table-column prop="name" label="指标"></el-table-column>
        <el-table-column prop="totalCount" label="合计"></el-table-column>
        <el-table-column
            :prop="item.prop"
            :label="item.label"
            :key="index"
            v-for="(item, index) in tableHead">
          </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="添加指标"
      :visible.sync="eventAnalysisLabelVisible">
      <el-tabs tab-position="left" style="height: 200px;" :value="activeTab" @tab-click="tabClick">
        <el-tab-pane :label="select.typeName" v-for="select in eventAnalysisLabelList" :key="select.typeName" :name="select.typeName">
          <div class="f f--c">
            <el-select v-model="select.eventID" @change="v => eventChange(select, v)" style="width: 260px">
              <el-option v-for="item in select.selectList" :key="item.id" :value="item.id" :label="item.notes"></el-option>
            </el-select>
            <span style="margin:0 8px">的</span>
            <el-select v-model="select.selectType" v-if="activeTab === '页面曝光事件'" @change="val => selectTypeChange(select, val)">
              <el-option :value="1" label="总次数(PV)"></el-option>
              <el-option :value="2" label="用户数(UV)"></el-option>
            </el-select>
            <el-select v-model="select.selectType" v-else>
              <el-option :value="2" label="用户数(UV)"></el-option>
            </el-select>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="eventAnalysisLabelVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCheck">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'

export default {
  data() {
    return {
      eventList: [],
      eventAnalysisLabelVisible: false,
      eventAnalysisLabelList: [],
      activeTab: undefined,
      chartDataSave: [],
      tableHead: [],
      dataList: [],
      showChart: 'myChart',
      dataSave: [],
      renderKey: 1
      // tab: 'line'
    }
  },
  created() {
  },
  mounted() {
    this.eventStudyGetEventList()
  },
  filters: {
    eventAnalysisLabelTypeMap(value) {
      const mapObj = {
        0: '页面曝光事件',
        1: '按钮点击事件',
        2: '业务事件'
      }
      return mapObj[value]
    }
  },
  methods: {
    handleClick() {
      this.chartData()
    },
    // 统计图设置
    chartData(data) {
      this.myChart = this.$echart.init(document.getElementById('myChart'))
      let options = this.generateOption(data)
      this.myChart.setOption(options)
    },
    chartHistogram(data) {
      this.histogram = this.$echart.init(document.getElementById('histogram'))
      let histogramOptions = this.histogramOption(data)
      this.histogram.setOption(histogramOptions)
    },
    // 配置统计图
    generateOption(data) {
      const legend = data.map(e=>e.name)
      let xAxisDataBase  = data.find(e=>e.dateDatas) || {dateDatas: []}
      let xAxisData = xAxisDataBase.dateDatas.map(e=>e.date)
      let series = []
      // 如果数据为空、需要每一项都设置为0
      // let emptyData = []
      data.forEach(e=>{
        const obj = {
          name: e.name,
          type: 'line',
          stack: 'Total',
          data: e.dateDatas ? e.dateDatas.map(e=>e.dateCount): []
        }
        series.push(obj)
      })
      const options = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: legend
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: series
      }
      return options
    },
    // 配置柱状图
    histogramOption(data) {
      let dimensions = ['product']
      data.forEach(e=>{
        dimensions.push(e.name)
      })
      // 找出所有日期
      const dateAllTarget = data.find(e=>e.dateDatas) || {dateDatas: []}
      const dateAll = dateAllTarget.dateDatas.map(e=>e.date)
      const source = []
      dateAll.forEach(date=>{
        const obj = {
          product: date
        }
        data.forEach(e=>{
          if(e.dateDatas) {
            obj[e.name] = e.dateDatas.find(ee=>ee.date === date).dateCount
          } else {
            obj[e.name] = 0
          }
        })
        source.push(obj)
      })
      let option = {
        legend: {},
        tooltip: {},
        dataset: {
          dimensions: dimensions,
          source: source
        },
        xAxis: { type: 'category' },
        yAxis: {},
        series: dimensions.slice(1).map(()=>({type:'bar'}))
      };
      return option
    },
    eventStudyGetEventList() {
      API.eventStudyGetEventList().then(res=>{
        res.data.forEach((e, i)=>{
          this.$set(e, 'eventID', null)// 事件
          this.$set(e, 'selectType', 2)
          this.$set(e, 'selectName', '用户数(UV)')
          if(i===0) {
            this.activeTab = e.typeName
          }
        })
        this.eventAnalysisLabelList = res.data
      })
    },
    addCheck() {
      // eventID eventName 事件名 selectType  selectName (pv/up)
      const { eventID: id, eventName: name, selectType:type, selectName } = this.eventAnalysisLabelList.find(e=>e.typeName === this.activeTab)
      if(this.eventList.some(e=>e.id === id && e.selectName === selectName)) {
        return this.$message.error('不可添加重复事件')
      }
      const content = [
        ...this.eventList,
        {id, name, type, selectName}
      ]
      const params = {
        type: 1,
        content: JSON.stringify(content)
      }
      if(content.length > 8) {
        return this.$message.warning('最多只能展示八项，不可再添加')
      }
      API.userBehaviorEdit(params).then(()=>{
        this.$message.success('保存成功')
        this.eventAnalysisLabelVisible = false
        this.userBehaviorGet()
        this.renderKey = new Date().valueOf()
      })
    },
    eventChange(select, val) {
      select.eventName = select.selectList.find(e=> e.id ===val).notes
      select.eventID = val
    },
    userBehaviorGet() {
      API.userBehaviorGet({type: 1}).then(res=>{
        this.eventList = JSON.parse(res.data)
        this.$emit('paramsChange', {selectList: this.eventList, isGetData: true})
      })
    },
    setChartData(data) {
      // 设置顶部tabs对应的数字
      this.eventList.forEach(e=>{
        data.forEach(d=>{
          if(d.name === e.name) this.$set(e, 'totalCount', d.totalCount)
        })
      })
      this.dataSave = data
      this.$nextTick(()=>{
        if(this.showChart === 'myChart') {
          this.chartData(data)
        } else {
          this.chartHistogram(data)
        }
      })
      this.renderTable(data)
    },
    setEventList(data) {
      this.eventList = data
    },
    eventDelete(i) {
      this.eventList.splice(i, 1)
      const params = {
        type: 1,
        content: JSON.stringify(this.eventList)
      }
      API.userBehaviorEdit(params).then(()=>{
        this.$message.success('删除成功')
        this.eventAnalysisLabelVisible = false
        this.userBehaviorGet()
        this.renderKey = new Date().valueOf()
      })
    },
    radioChange(value) {
      this.renderKey = new Date().valueOf()
      this.$nextTick(()=>{
        if(value === 'myChart') {
          this.chartData(this.dataSave)
        } else {
          this.chartHistogram(this.dataSave)
        }
      })
    },
    renderTable(data) {
      // 表格渲染
      const dataList = []
      let tableHead = data.find(e=>e.dateDatas) || {dateDatas: []}
      tableHead = tableHead.dateDatas.map(e=>{
        return {
          label: e.date,
          prop: e.date
        }
      })
      this.tableHead = tableHead
      data.forEach(e=>{
        const obj = {
          name: e.name,
          totalCount: e.totalCount
        }
        if(e.dateDatas) {
          e.dateDatas.forEach(date=>{
            obj[date.date] = date.dateCount
          })
        } else {
          tableHead.forEach(date=>{
            obj[date.prop] = 0
          })
        }
        dataList.push(obj)
      })
      this.dataList = dataList
    },
    tabClick(val) {
      this.activeTab = val.label
      const target = this.eventAnalysisLabelList.find(e=>e.typeName === this.activeTab)
    },
    selectTypeChange(select, val) {
      const selectMap = {
        1: '总次数(PV)',
        2: '用户数(UV)'
      }
      select.selectName = selectMap[val]
    },
    exportData() {
      this.$emit('exportData')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  .event {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 20px;
    .event-item {
      width: 23%;
      height: 110px;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      background-color: #fff;
      border-radius: 6px;
      margin-right: 2.4%;
      margin-bottom: 20px;
      box-shadow: 0px 4px 14px 6px rgba(205, 212, 221, 0.1);
      .event-close{
        position: absolute;
        right: 4px;
        top: 4px;
        width: 24px;
        height: 24px;
      }
      .num{
        margin-top: 10px;
        font-weight: 600;
      }
      .icon{
        margin-top: 10px;
        .icon-shuju3 {
          color: #2F80ED;
          font-size: 20px;
        }
      }
    }
    .event-item:nth-child(4n+4){
      margin-right: 0;
    }
    .active{
      border: 2px solid #99C41C;
      box-shadow: 0px 4px 14px 6px rgba(205, 212, 221, 0.1);
    }
  }
  .chart-head{
    background-color: #fff;
    height: 50px;
    .chart-title{
      font-size: 20px;
    }
    .chart-tab{
      position: absolute;
      right: 30px;
      box-sizing: border-box;
      width: 150px;
      height: 40px;
      /deep/ .el-radio-button__inner{
        padding: 8px 16px;
      }
      span i{
        font-size: 24px;
      }
      .el-icon-s-data {
        padding-top: 2px;
      }
    }
  }
  #myChart {
    padding: 10px;
    width: 100%;
    height: 600px;
    background-color: #fff;
  }
  #histogram{
    padding: 10px;
    width: 100%;
    height: 600px;
    background-color: #fff;
  }
}
</style>